import { defineMessages } from "@/i18n";
import en from "./en";

export const framesBoardMessages = defineMessages("frames-board", en);
